import React from 'react';
import styled from 'styled-components';
import * as S from './SRPCardLoader.styles';
// import SrpCardLeftComponent from '../SrpCardLeftComponent/SrpCardLeftComponent';
// import SrpCardRightComponent from '../SrpCardRightComponent/SrpCardRightComponent';
import {Theme} from './../../../../../theme/types';
import {Column, Row} from '../../common/Layouts/Layouts';

const SRPCardLoader = () => (
  <>
    <S.SrpCardAllComponentWrapDiv>
      <S.SrpCardLeftComponentWrapDiv>
        <S.GalaryBlockComponentWrapDiv>
          <S.HotelImageComponentWrapDiv></S.HotelImageComponentWrapDiv>
          <S.HotelSmallInnerWrapDiv>
            <S.HotelSmallInnerListWrap></S.HotelSmallInnerListWrap>
            <S.HotelSmallInnerListWrap></S.HotelSmallInnerListWrap>
            <S.HotelSmallInnerListWrap></S.HotelSmallInnerListWrap>
            <S.HotelSmallInnerListWrap></S.HotelSmallInnerListWrap>
            <S.HotelSmallInnerListWrap></S.HotelSmallInnerListWrap>
          </S.HotelSmallInnerWrapDiv>
        </S.GalaryBlockComponentWrapDiv>
        <S.HotelDetailsLoaderComponentWrapDiv>
          <Column>
            <S.HotelDetailsFirstLoaderWrapDiv>
              <S.RatingLoaderWrapSpan></S.RatingLoaderWrapSpan>
              <S.RatingLoaderWrapSpan></S.RatingLoaderWrapSpan>
            </S.HotelDetailsFirstLoaderWrapDiv>
            <S.HotelNameLoaderWrapDiv></S.HotelNameLoaderWrapDiv>
            <S.AddressLoaderWrapDiv></S.AddressLoaderWrapDiv>
          </Column>

          <Column>
            <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
            <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
            <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
            <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
          </Column>
        </S.HotelDetailsLoaderComponentWrapDiv>
      </S.SrpCardLeftComponentWrapDiv>
      <S.SrpCardRightComponentWrapDiv>
        <S.FirstPricingComponentWrapDiv></S.FirstPricingComponentWrapDiv>
        <S.SecondPricingComponentWrapDiv>
          <S.StrikedPriceWrapDiv />
          <S.OriginalPriceLoaderDiv />
          <S.TaxLoaderDiv />
          <S.OfferLoaderDiv />
          <S.PriceBtnDiv> </S.PriceBtnDiv>
          <S.AlertWrapDiv />
        </S.SecondPricingComponentWrapDiv>
      </S.SrpCardRightComponentWrapDiv>
    </S.SrpCardAllComponentWrapDiv>
  </>
);

export default SRPCardLoader;
